import { useLayoutEffect, useState, type RefObject } from "react";
import { findRenderedBlockInstances } from "./renderedDom";

/**
 * Measures a computed style on a block's first rendered instance,
 * re-measuring whenever the selection or its authored values change.
 * @param previewRef - The preview container
 * @param nodeId - The selected block's positional node id, or null
 * @param property - The CSS property to measure
 * @param authored - The block's authored values, remeasured when they change
 * @returns The computed value, or "" when nothing is selected
 */
export function useRenderedStyle(
  previewRef: RefObject<HTMLDivElement>,
  nodeId: string | null,
  property: string,
  authored: string,
): string {
  const [value, setValue] = useState("");
  useLayoutEffect(() => {
    const container = previewRef.current;
    if (!container || nodeId === null) {
      setValue("");
      return;
    }
    const instance = findRenderedBlockInstances(container, nodeId)[0];
    setValue(
      instance
        ? window.getComputedStyle(instance).getPropertyValue(property)
        : "",
    );
  }, [previewRef, nodeId, property, authored]);
  return value;
}
